"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchiveSignupNotifyAction = exports.SignupFilterEnum = exports.Signup = exports.MinimalSignup = exports.Region = exports.SignupProductType = exports.SignupRestrictionsEnum = exports.OverallSignupStatusEnum = exports.CreationSourceEnum = exports.SignupStatus = exports.DataStatusEnum = exports.ParserStatusEnum = exports.ManagerStatusEnum = exports.AgencySetupStatusEnum = void 0;
var cerealParse_1 = require("../cerealParse");
var agent_1 = require("./agent");
var country_1 = require("./country");
var AgencySetupStatusEnum;
(function (AgencySetupStatusEnum) {
    AgencySetupStatusEnum[AgencySetupStatusEnum["signup"] = 0] = "signup";
    AgencySetupStatusEnum[AgencySetupStatusEnum["agency"] = 1] = "agency";
    AgencySetupStatusEnum[AgencySetupStatusEnum["units"] = 2] = "units";
})(AgencySetupStatusEnum || (exports.AgencySetupStatusEnum = AgencySetupStatusEnum = {}));
var ManagerStatusEnum;
(function (ManagerStatusEnum) {
    ManagerStatusEnum[ManagerStatusEnum["none"] = 0] = "none";
    ManagerStatusEnum[ManagerStatusEnum["set"] = 1] = "set";
})(ManagerStatusEnum || (exports.ManagerStatusEnum = ManagerStatusEnum = {}));
var ParserStatusEnum;
(function (ParserStatusEnum) {
    ParserStatusEnum[ParserStatusEnum["none"] = 0] = "none";
    ParserStatusEnum[ParserStatusEnum["development"] = 1] = "development";
    ParserStatusEnum[ParserStatusEnum["testing"] = 2] = "testing";
    ParserStatusEnum[ParserStatusEnum["ready"] = 3] = "ready";
})(ParserStatusEnum || (exports.ParserStatusEnum = ParserStatusEnum = {}));
var DataStatusEnum;
(function (DataStatusEnum) {
    DataStatusEnum[DataStatusEnum["none"] = 0] = "none";
    DataStatusEnum[DataStatusEnum["test"] = 1] = "test";
    DataStatusEnum[DataStatusEnum["jobs"] = 2] = "jobs";
})(DataStatusEnum || (exports.DataStatusEnum = DataStatusEnum = {}));
var SignupStatus = /** @class */ (function () {
    function SignupStatus(agencySetupStatus, managerStatus, parserStatus, dataStatus) {
        this.agencySetupStatus = agencySetupStatus;
        this.managerStatus = managerStatus;
        this.parserStatus = parserStatus;
        this.dataStatus = dataStatus;
    }
    SignupStatus.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SignupStatus(cerealParse_1.ParseUtils.getEnum(o, 'agencySetup', AgencySetupStatusEnum), cerealParse_1.ParseUtils.getEnum(o, 'manager', ManagerStatusEnum), cerealParse_1.ParseUtils.getEnum(o, 'parser', ParserStatusEnum), cerealParse_1.ParseUtils.getEnum(o, 'data', DataStatusEnum)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SignupStatus: ".concat(e.message));
        }
    };
    SignupStatus.prototype.copy = function () {
        return new SignupStatus(this.agencySetupStatus, this.managerStatus, this.parserStatus, this.dataStatus);
    };
    SignupStatus.prototype.toOverallStatus = function () {
        var isTodo = this.agencySetupStatus == AgencySetupStatusEnum.signup &&
            this.managerStatus == ManagerStatusEnum.none &&
            this.parserStatus == ParserStatusEnum.none &&
            this.dataStatus == DataStatusEnum.none;
        var isDone = this.agencySetupStatus == AgencySetupStatusEnum.units &&
            this.managerStatus == ManagerStatusEnum.set &&
            this.parserStatus == ParserStatusEnum.ready &&
            this.dataStatus == DataStatusEnum.jobs;
        return isTodo ? OverallSignupStatusEnum.todo
            : isDone ? OverallSignupStatusEnum.done
                : OverallSignupStatusEnum.inProgress;
    };
    return SignupStatus;
}());
exports.SignupStatus = SignupStatus;
var CreationSourceEnum;
(function (CreationSourceEnum) {
    CreationSourceEnum[CreationSourceEnum["api"] = 0] = "api";
    CreationSourceEnum[CreationSourceEnum["manual"] = 1] = "manual";
})(CreationSourceEnum || (exports.CreationSourceEnum = CreationSourceEnum = {}));
var OverallSignupStatusEnum;
(function (OverallSignupStatusEnum) {
    OverallSignupStatusEnum[OverallSignupStatusEnum["todo"] = 0] = "todo";
    OverallSignupStatusEnum[OverallSignupStatusEnum["inProgress"] = 1] = "inProgress";
    OverallSignupStatusEnum[OverallSignupStatusEnum["done"] = 2] = "done";
})(OverallSignupStatusEnum || (exports.OverallSignupStatusEnum = OverallSignupStatusEnum = {}));
var SignupRestrictionsEnum;
(function (SignupRestrictionsEnum) {
    SignupRestrictionsEnum[SignupRestrictionsEnum["myLeads"] = 0] = "myLeads";
    SignupRestrictionsEnum[SignupRestrictionsEnum["archived"] = 1] = "archived";
})(SignupRestrictionsEnum || (exports.SignupRestrictionsEnum = SignupRestrictionsEnum = {}));
var SignupProductType;
(function (SignupProductType) {
    SignupProductType[SignupProductType["bryx911"] = 0] = "bryx911";
    SignupProductType[SignupProductType["bryxStation"] = 1] = "bryxStation";
    SignupProductType[SignupProductType["bryxHospital"] = 2] = "bryxHospital";
})(SignupProductType || (exports.SignupProductType = SignupProductType = {}));
var Region = /** @class */ (function () {
    function Region(code, name) {
        this.code = code;
        this.name = name;
    }
    Region.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Region(cerealParse_1.ParseUtils.getString(o, 'code'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Region: ".concat(e.message));
        }
    };
    return Region;
}());
exports.Region = Region;
var MinimalSignup = /** @class */ (function () {
    function MinimalSignup(id, name, region, country, overallStatus, archived, productType) {
        this.id = id;
        this.name = name;
        this.region = region;
        this.country = country;
        this.overallStatus = overallStatus;
        this.archived = archived;
        this.productType = productType;
    }
    MinimalSignup.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalSignup(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'region'), cerealParse_1.ParseUtils.getString(o, 'country'), cerealParse_1.ParseUtils.getEnum(o, 'overallStatus', OverallSignupStatusEnum), cerealParse_1.ParseUtils.getBoolean(o, 'archived'), cerealParse_1.ParseUtils.getArray(o, 'products').map(function (e) { return SignupProductType[e]; })));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalSignup: ".concat(e.message));
        }
    };
    return MinimalSignup;
}());
exports.MinimalSignup = MinimalSignup;
var Signup = /** @class */ (function () {
    function Signup(id, name, region, country, alertEmail, creationTs, creationSource, dataCount, currentlyWatching, overallStatus, archived, productType, salesLead, technicalLead, agencyId) {
        this.id = id;
        this.name = name;
        this.region = region;
        this.country = country;
        this.alertEmail = alertEmail;
        this.creationTs = creationTs;
        this.creationSource = creationSource;
        this.dataCount = dataCount;
        this.currentlyWatching = currentlyWatching;
        this.overallStatus = overallStatus;
        this.archived = archived;
        this.productType = productType;
        this.salesLead = salesLead;
        this.technicalLead = technicalLead;
        this.agencyId = agencyId;
    }
    Signup.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Signup(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'region'), cerealParse_1.ParseUtils.getEnum(o, 'country', country_1.CountryKey), cerealParse_1.ParseUtils.getString(o, 'alertEmail'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'creationTs'), cerealParse_1.ParseUtils.getEnum(o, 'creationSource', CreationSourceEnum), cerealParse_1.ParseUtils.getNumber(o, 'dataCount'), cerealParse_1.ParseUtils.getBoolean(o, 'currentlyWatching'), cerealParse_1.ParseUtils.getEnum(o, 'overallStatus', OverallSignupStatusEnum), cerealParse_1.ParseUtils.getBoolean(o, 'archived'), cerealParse_1.ParseUtils.getArray(o, 'products').map(function (e) { return SignupProductType[e]; }), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'salesLead', agent_1.MinimalStaff.parse), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'technicalLead', agent_1.MinimalStaff.parse), cerealParse_1.ParseUtils.getStringOrNull(o, 'agencyId')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Signup: ".concat(e.message));
        }
    };
    Signup.getOverallStatusLabelContent = function (overallStatus) {
        switch (overallStatus) {
            case OverallSignupStatusEnum.todo:
                return 'To Do';
            case OverallSignupStatusEnum.inProgress:
                return 'In Progress';
            case OverallSignupStatusEnum.done:
                return 'Done';
        }
    };
    return Signup;
}());
exports.Signup = Signup;
var SignupFilterEnum;
(function (SignupFilterEnum) {
    SignupFilterEnum[SignupFilterEnum["none"] = 0] = "none";
    SignupFilterEnum[SignupFilterEnum["myLeads"] = 1] = "myLeads";
})(SignupFilterEnum || (exports.SignupFilterEnum = SignupFilterEnum = {}));
var ArchiveSignupNotifyAction;
(function (ArchiveSignupNotifyAction) {
    ArchiveSignupNotifyAction[ArchiveSignupNotifyAction["noData"] = 0] = "noData";
    ArchiveSignupNotifyAction[ArchiveSignupNotifyAction["alreadySignedUp"] = 1] = "alreadySignedUp";
})(ArchiveSignupNotifyAction || (exports.ArchiveSignupNotifyAction = ArchiveSignupNotifyAction = {}));
//# sourceMappingURL=signup.js.map